/**
 * @generated SignedSource<<0c23c76eb698570c79edade1e4eb7da5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "offerName"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "offerName",
        "variableName": "offerName"
      }
    ],
    "concreteType": "BasicMutationResponse",
    "kind": "LinkedField",
    "name": "createOffer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateOfferMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateOfferMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "95dbbfb44376ae742d70b4e1b4d8ca89",
    "id": null,
    "metadata": {},
    "name": "CreateOfferMutation",
    "operationKind": "mutation",
    "text": "mutation CreateOfferMutation(\n  $offerName: String!\n) {\n  createOffer(offerName: $offerName) {\n    ok\n    error\n  }\n}\n"
  }
};
})();

node.hash = "45c9a3209b234e22ec8674b00c36ed22";

export default node;
